<script setup lang="ts">
import { TrackEventData } from '@/constants/track'
import { useAppStore } from '@/store'

const appStore = useAppStore()
</script>

<template>
  <n-tooltip placement="bottom" trigger="hover">
    <template #trigger>
      <CommonWrapper
        v-track="() => ({ type: 'Icon_Button', data: appStore.collapsed ? '侧边栏折叠' : '侧边栏展开', public: true })"
        class="!lt-md:hidden" @click="appStore.toggleCollapse()"
      >
        <icon-park-outline-menu-unfold v-if="appStore.collapsed" />
        <icon-park-outline-menu-fold v-else />
      </CommonWrapper>
    </template>
    <span>切换侧边栏</span>
  </n-tooltip>
  <CommonWrapper class="hidden lt-md:block" @click="appStore.toggleCollapse()">
    <icon-park-outline-menu-unfold v-if="appStore.collapsed" />
    <icon-park-outline-menu-fold v-else />
  </CommonWrapper>
</template>

<style scoped></style>
